import { filtersActions } from './filters-slice';

export const setFilters = (dispatch, filters) => {
  dispatch(filtersActions.setFilters(filters));
};

export const resetFilters = dispatch => {
  dispatch(filtersActions.reset());
};
